export const assetPNEO = {
  id: 222,
  height: 3760351,
  data: {
    icon: "/imgs/icons/asset/planetneo.png",
    about:
      "Planet Neo is a collection of imaginary worlds designed to make the real world a better place. Get moving and solve global challenges with games, world building, and real-life experiences. We build brands with purpose to make life better.",
    links: [
      {
        name: "Website",
        url: "https://www.planetneo.com",
      },
      {
        name: "Twitter: @planetneo_com",
        url: "https://twitter.com/planetneo_com",
        icon: "/imgs/icons/link-x.svg",
      },
      {
        name: "Discord",
        url: "https://discord.com/invite/3NKZxX7QPq",
        icon: "/imgs/icons/link-discord.svg",
      },
    ],
    governances: [
      {
        spaceLogo: "/imgs/icons/asset/rmrkdao.png",
        spaceName: "NFT Polling",
        projectName: "RMRK DAO",
        link: "https://rmrkdao.app",
      },
    ],
  },
};
